<template>
  <div class="login">
    <b-container>
      <b-row>
        <b-col md="7" lg="5">
          <div class="form-decorated">
            <loader v-if="isLoading" />

            <b-form @submit.prevent="onSubmit" novalidate>
              <b-form-group id="password" label="Choose your password" label-for="password">
                <b-form-input id="password" type="password" v-model="form.password" :state="getFieldState('password')" />

                <b-form-invalid-feedback>
                  {{ !$v.form.password.required ? 'Password is required' : `Password must have at least ${$v.form.password.$params.minLength.min} letters` }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="repeat-password" label="Repeat your password" label-for="repeat-password">
                <b-form-input id="repeat-password" type="password" v-model="form.repeatPassword" :state="getFieldState('repeatPassword')" />

                <b-form-invalid-feedback>
                  Password does not match
                </b-form-invalid-feedback>
              </b-form-group>

              <b-button type="submit" class="btn-decorated">Reset Password</b-button>
            </b-form>
          </div>

        </b-col>
        <b-col align-self="end" class="title">
          <h1>
            Full <br>
            music <br>
            experience
          </h1>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Loader from '@/components/widgets/Loader'
import { validationMixin } from 'vuelidate'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'ResetPassword',
  components: {
    Loader
  },
  data () {
    return {
      form: {
        password: '',
        repeatPassword: ''
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8)
      },
      repeatPassword: {
        sameAsPassword: sameAs('password')
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoading', 'error'])
  },
  methods: {
    getFieldState (name) {
      const field = this.$v.form[name]

      if (typeof field === 'undefined') {
        return null
      }

      if (field.$dirty && field.$error) {
        return false
      }

      return null
    },

    async onSubmit (evt) {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      try {
        await this.$store.dispatch('auth/confirmResetPassword', {
          uid: this.$route.params.uid,
          token: this.$route.params.token,
          password: this.form.password
        })
      } catch (e) {
        this.$store.dispatch('flash/showMessage', { message: 'Can\'t change password', type: 'error' })
        return
      }

      this.$store.dispatch('flash/showMessage', { message: 'Password changed' })
      this.$router.push({name: 'account-login'})
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

.login {
  margin: -48px -15px 0 -15px;
  padding-top: 48px;
  background-image: linear-gradient(to bottom, rgba(0,0,0,0) 57%, $body-bg),
                    url(/static/img/login-signup-bg.jpg);

  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  min-height: 90vh;

  .row {
    margin-top: 5em;
    margin-bottom: 5em;
  }

  .title {
    display: none;
    flex-direction: row-reverse;

    h1 {
      font-size: 4rem;
    }
  }

  @include media-breakpoint-up(lg) {
    .title {
      display: flex;
    }
  }
}

.form-decorated {
  margin: 3em;

  form {
    position: relative;
    z-index: 1;
  }

  .btn-decorated {
    position: absolute;
    left: calc(50% - 85px);
  }

  .errors {
    font-size: 0.8em;
  }
}

.social-login {
  margin: 0 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/account/ResetPassword.vue